module.exports = __webpack_public_path__ + "2e1afa6d84e1a55d80b069d463045f2a.jpg";